export const detectedFilters = ['contactClosures'];
export function isDetectedFilter(filter) {
    return detectedFilters.some(f => f === filter);
}
export const dspDetectedFilterNames = [
    'amplifier',
    'assistiveListeningMute',
    'assistiveListeningMuteStatus',
    'assistiveListeningVolume',
    'audioInputMute',
    'audioInputMuteStatus',
    'audioInputVolume',
    'mics',
    'micsMuteStatus',
    'overflowRoomMute',
    'overflowRoomMuteStatus',
    'overflowRoomVolume',
    'preset',
    'receiveGain',
    'soundReinforcementMute',
    'soundReinforcementMuteStatus',
    'soundReinforcementVolume',
    'telephony',
];
export function isDspDetectedFilterName(value) {
    return dspDetectedFilterNames.some(n => n === value);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValid(obj, isEmptyInvalid = false, isOfflineInvalid = true) {
    if (typeof obj === 'string') {
        if (isOfflineInvalid) {
            return obj === 'ok';
        }
        else {
            return obj === 'ok' || obj === 'offline';
        }
    }
    if (obj === null || typeof obj !== 'object')
        throw new Error('invalid validated object');
    const values = Object.values(obj);
    if (isEmptyInvalid && values.length <= 0)
        return false;
    for (const value of values) {
        if (!isValid(value, isEmptyInvalid, isOfflineInvalid))
            return false;
    }
    return true;
}
